import {
  FETCH_SMM_POST_CHANNEL_STATUS_LIST,
  FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS,
  FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE,
  CREATE_SMM_POST_CHANNEL_STATUS,
  CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  CREATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  UPDATE_SMM_POST_CHANNEL_STATUS,
  UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  DELETE_SMM_POST_CHANNEL_STATUS,
  DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  DELETE_SMM_POST_CHANNEL_STATUS_FAILURE,
  FETCH_SMM_POST_LIST,
  FETCH_SMM_POST_LIST_SUCCESS,
  FETCH_SMM_POST_LIST_FAILURE,
  FETCH_SMM_POST_DATA,
  FETCH_SMM_POST_DATA_SUCCESS,
  FETCH_SMM_POST_DATA_FAILURE,
  CREATE_SMM_POST,
  CREATE_SMM_POST_SUCCESS,
  CREATE_SMM_POST_FAILURE,
  UPDATE_SMM_POST,
  UPDATE_SMM_POST_SUCCESS,
  UPDATE_SMM_POST_FAILURE,
  DELETE_SMM_POST,
  DELETE_SMM_POST_SUCCESS,
  DELETE_SMM_POST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  GENERATE_SMM_POST_CONTENT,
  GENERATE_SMM_POST_CONTENT_SUCCESS,
  GENERATE_SMM_POST_CONTENT_FAILURE,
  GENERATE_SMM_POST_IMAGE,
  GENERATE_SMM_POST_IMAGE_SUCCESS,
  GENERATE_SMM_POST_IMAGE_FAILURE,
  SOCIAL_MEDIA_CONNECT_START,
  SOCIAL_MEDIA_CONNECT_START_SUCCESS,
  SOCIAL_MEDIA_CONNECT_START_FAILURE,
  SOCIAL_MEDIA_CONNECT_COMPLETE,
  SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS,
  SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE,
  SOCIAL_MEDIA_CONNECT_ASSIGN,
  SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS,
  SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE,
  SOCIAL_MEDIA_CONNECT_DISCONNECT,
  SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS,
  SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE,
} from "./actionType";

// Initial State
const initialState = {
  postChannelStatusList: [],
  postChannelStatusListLoading: false,

  postChannelStatusData: null,
  postChannelStatusDataLoading: false,

  postChannelStatusCreateSuccess: [],
  postChannelStatusCreateLoading: false,

  postChannelStatusUpdateSuccess: [],
  postChannelStatusUpdateLoading: false,

  postChannelStatusDeleteSuccess: [],
  postChannelStatusDeleteLoading: false,

  postList: [],
  postListLoading: false,

  postData: null,
  postDataLoading: false,

  postCreateSuccess: [],
  postCreateLoading: false,

  postUpdateSuccess: [],
  postUpdateLoading: false,

  postDeleteSuccess: [],
  postDeleteLoading: false,

  masterSocialMediaProviderList: [],
  masterSocialMediaProviderListLoading: false,

  masterSocialMediaProviderData: null,
  masterSocialMediaProviderDataLoading: false,

  masterSocialMediaProviderCreateSuccess: [],
  masterSocialMediaProviderCreateLoading: false,

  masterSocialMediaProviderUpdateSuccess: [],
  masterSocialMediaProviderUpdateLoading: false,

  masterSocialMediaProviderDeleteSuccess: [],
  masterSocialMediaProviderDeleteLoading: false,

  masterSocialMediaProfileList: [],
  masterSocialMediaProfileListLoading: false,

  masterSocialMediaProfileData: null,
  masterSocialMediaProfileDataLoading: false,

  masterSocialMediaProfileCreateSuccess: [],
  masterSocialMediaProfileCreateLoading: false,

  masterSocialMediaProfileUpdateSuccess: [],
  masterSocialMediaProfileUpdateLoading: false,

  masterSocialMediaProfileDeleteSuccess: [],
  masterSocialMediaProfileDeleteLoading: false,

  // Task 24873 - social channel connection.
  // connectStartSuccess carries the authorise URL; connectCompleteSuccess
  // carries the list of accounts the token can post to.
  connectStartSuccess: [],
  connectStartLoading: false,
  connectCompleteSuccess: [],
  connectCompleteLoading: false,
  // A thrown request never populates *Success. Without somewhere for the throw
  // to land, the callback page would spin for ever on a dropped connection.
  connectCompleteError: null,
  connectAssignSuccess: [],
  connectAssignLoading: false,
  connectAssignError: null,
  connectDisconnectSuccess: [],
  connectDisconnectLoading: false,

  generatePostContentSuccess: [],
  generatePostContentLoading: false,

  //GENERATE_SMM_POST_IMAGE
  generatePostImageSuccess: [],
  generatePostImageLoading: false,
};

// Reducer
const socialMediaManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    //FETCH_SMM_POST_CHANNEL_STATUS_LIST
    case FETCH_SMM_POST_CHANNEL_STATUS_LIST:
      return {
        ...state,
        postChannelStatusListLoading: true,
      };
    case FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS:
      return {
        ...state,
        postChannelStatusList: action.payload,
        postChannelStatusListLoading: false,
      };
    case FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE:
      return {
        ...state,
        postChannelStatusListLoading: false,
      };
    //FETCH_SMM_POST_CHANNEL_STATUS_DATA
    case FETCH_SMM_POST_CHANNEL_STATUS_DATA:
      return {
        ...state,
        postChannelStatusDataLoading: true,
      };
    case FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS:
      return {
        ...state,
        postChannelStatusData: action.payload,
        postChannelStatusDataLoading: false,
      };
    case FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE:
      return {
        ...state,
        postChannelStatusDataLoading: false,
      };
    //CREATE_SMM_POST_CHANNEL_STATUS
    case CREATE_SMM_POST_CHANNEL_STATUS:
      return {
        ...state,
        postChannelStatusCreateLoading: true,
      };
    case CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS:
      return {
        ...state,
        postChannelStatusCreateSuccess: action.payload,
        postChannelStatusCreateLoading: false,
      };
    case CREATE_SMM_POST_CHANNEL_STATUS_FAILURE:
      return {
        ...state,
        postChannelStatusCreateLoading: false,
      };
    //UPDATE_SMM_POST_CHANNEL_STATUS
    case UPDATE_SMM_POST_CHANNEL_STATUS:
      return {
        ...state,
        postChannelStatusUpdateLoading: true,
      };
    case UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS:
      return {
        ...state,
        postChannelStatusUpdateSuccess: action.payload,
        postChannelStatusUpdateLoading: false,
      };
    case UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE:
      return {
        ...state,
        postChannelStatusUpdateLoading: false,
      };
    //DELETE_SMM_POST_CHANNEL_STATUS
    case DELETE_SMM_POST_CHANNEL_STATUS:
      return {
        ...state,
        postChannelStatusDeleteLoading: true,
      };
    case DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS:
      return {
        ...state,
        postChannelStatusDeleteSuccess: action.payload,
        postChannelStatusDeleteLoading: false,
      };
    case DELETE_SMM_POST_CHANNEL_STATUS_FAILURE:
      return {
        ...state,
        postChannelStatusDeleteLoading: false,
      };
    //FETCH_SMM_POST_LIST
    case FETCH_SMM_POST_LIST:
      return {
        ...state,
        postListLoading: true,
      };
    case FETCH_SMM_POST_LIST_SUCCESS:
      return {
        ...state,
        postList: action.payload,
        postListLoading: false,
      };
    case FETCH_SMM_POST_LIST_FAILURE:
      return {
        ...state,
        postListLoading: false,
      };
    //FETCH_SMM_POST_DATA
    case FETCH_SMM_POST_DATA:
      return {
        ...state,
        postDataLoading: true,
      };
    case FETCH_SMM_POST_DATA_SUCCESS:
      return {
        ...state,
        postData: action.payload,
        postDataLoading: false,
      };
    case FETCH_SMM_POST_DATA_FAILURE:
      return {
        ...state,
        postDataLoading: false,
      };
    //CREATE_SMM_POST
    case CREATE_SMM_POST:
      return {
        ...state,
        postCreateLoading: true,
      };
    case CREATE_SMM_POST_SUCCESS:
      return {
        ...state,
        postCreateSuccess: action.payload,
        postCreateLoading: false,
      };
    case CREATE_SMM_POST_FAILURE:
      return {
        ...state,
        postCreateLoading: false,
      };
    //UPDATE_SMM_POST
    case UPDATE_SMM_POST:
      return {
        ...state,
        postUpdateLoading: true,
      };
    case UPDATE_SMM_POST_SUCCESS:
      return {
        ...state,
        postUpdateSuccess: action.payload,
        postUpdateLoading: false,
      };
    case UPDATE_SMM_POST_FAILURE:
      return {
        ...state,
        postUpdateLoading: false,
      };
    //DELETE_SMM_POST
    case DELETE_SMM_POST:
      return {
        ...state,
        postDeleteLoading: true,
      };
    case DELETE_SMM_POST_SUCCESS:
      return {
        ...state,
        postDeleteSuccess: action.payload,
        postDeleteLoading: false,
      };
    case DELETE_SMM_POST_FAILURE:
      return {
        ...state,
        postDeleteLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST:
      return {
        ...state,
        masterSocialMediaProviderListLoading: true,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        masterSocialMediaProviderList: action.payload,
        masterSocialMediaProviderListLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        masterSocialMediaProviderListLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA:
      return {
        ...state,
        masterSocialMediaProviderDataLoading: true,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS:
      return {
        ...state,
        masterSocialMediaProviderData: action.payload,
        masterSocialMediaProviderDataLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE:
      return {
        ...state,
        masterSocialMediaProviderDataLoading: false,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROVIDER:
      return {
        ...state,
        masterSocialMediaProviderCreateLoading: true,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS:
      return {
        ...state,
        masterSocialMediaProviderCreateSuccess: action.payload,
        masterSocialMediaProviderCreateLoading: false,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE:
      return {
        ...state,
        masterSocialMediaProviderCreateLoading: false,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER:
      return {
        ...state,
        masterSocialMediaProviderUpdateLoading: true,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS:
      return {
        ...state,
        masterSocialMediaProviderUpdateSuccess: action.payload,
        masterSocialMediaProviderUpdateLoading: false,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE:
      return {
        ...state,
        masterSocialMediaProviderUpdateLoading: false,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROVIDER:
      return {
        ...state,
        masterSocialMediaProviderDeleteLoading: true,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS:
      return {
        ...state,
        masterSocialMediaProviderDeleteSuccess: action.payload,
        masterSocialMediaProviderDeleteLoading: false,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE:
      return {
        ...state,
        masterSocialMediaProviderDeleteLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST:
      return {
        ...state,
        masterSocialMediaProfileListLoading: true,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS:
      return {
        ...state,
        masterSocialMediaProfileList: action.payload,
        masterSocialMediaProfileListLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE:
      return {
        ...state,
        masterSocialMediaProfileListLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA:
      return {
        ...state,
        masterSocialMediaProfileDataLoading: true,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        masterSocialMediaProfileData: action.payload,
        masterSocialMediaProfileDataLoading: false,
      };
    case FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE:
      return {
        ...state,
        masterSocialMediaProfileDataLoading: false,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        masterSocialMediaProfileCreateLoading: true,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS:
      return {
        ...state,
        masterSocialMediaProfileCreateSuccess: action.payload,
        masterSocialMediaProfileCreateLoading: false,
      };
    case CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE:
      return {
        ...state,
        masterSocialMediaProfileCreateLoading: false,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        masterSocialMediaProfileUpdateLoading: true,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS:
      return {
        ...state,
        masterSocialMediaProfileUpdateSuccess: action.payload,
        masterSocialMediaProfileUpdateLoading: false,
      };
    case UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE:
      return {
        ...state,
        masterSocialMediaProfileUpdateLoading: false,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        masterSocialMediaProfileDeleteLoading: true,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS:
      return {
        ...state,
        masterSocialMediaProfileDeleteSuccess: action.payload,
        masterSocialMediaProfileDeleteLoading: false,
      };
    case DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE:
      return {
        ...state,
        masterSocialMediaProfileDeleteLoading: false,
      };
    case GENERATE_SMM_POST_CONTENT:
      return {
        ...state,
        generatePostContentLoading: true,
      };
    case GENERATE_SMM_POST_CONTENT_SUCCESS:
      return {
        ...state,
        generatePostContentSuccess: action.payload,
        generatePostContentLoading: false,
      };
    case GENERATE_SMM_POST_CONTENT_FAILURE:
      return {
        ...state,
        generatePostContentLoading: false,
      };
    //GENERATE_SMM_POST_IMAGE
    case GENERATE_SMM_POST_IMAGE:
      return {
        ...state,
        generatePostImageLoading: true,
      };
    case GENERATE_SMM_POST_IMAGE_SUCCESS:
      return {
        ...state,
        generatePostImageSuccess: action.payload,
        generatePostImageLoading: false,
      };
    case GENERATE_SMM_POST_IMAGE_FAILURE:
      return {
        ...state,
        generatePostImageLoading: false,
      };
    // ------------------------------------------------ Task 24873, connect ---
    case SOCIAL_MEDIA_CONNECT_START:
      return { ...state, connectStartLoading: true };
    case SOCIAL_MEDIA_CONNECT_START_SUCCESS:
      return {
        ...state,
        connectStartSuccess: action.payload,
        connectStartLoading: false,
      };
    case SOCIAL_MEDIA_CONNECT_START_FAILURE:
      return { ...state, connectStartLoading: false };

    case SOCIAL_MEDIA_CONNECT_COMPLETE:
      return { ...state, connectCompleteLoading: true, connectCompleteError: null };
    case SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS:
      return {
        ...state,
        connectCompleteSuccess: action.payload,
        connectCompleteLoading: false,
      };
    case SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE:
      return {
        ...state,
        connectCompleteLoading: false,
        connectCompleteError: action.payload || true,
      };

    case SOCIAL_MEDIA_CONNECT_ASSIGN:
      return { ...state, connectAssignLoading: true, connectAssignError: null };
    case SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS:
      return {
        ...state,
        connectAssignSuccess: action.payload,
        connectAssignLoading: false,
      };
    case SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE:
      return {
        ...state,
        connectAssignLoading: false,
        connectAssignError: action.payload || true,
      };

    case SOCIAL_MEDIA_CONNECT_DISCONNECT:
      return { ...state, connectDisconnectLoading: true };
    case SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS:
      return {
        ...state,
        connectDisconnectSuccess: action.payload,
        connectDisconnectLoading: false,
      };
    case SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE:
      return { ...state, connectDisconnectLoading: false };

    default:
      return state;
  }
};

// Export Reducer
export default socialMediaManagementReducer;
